export const SIDEBAR = {
  APPSEC: 'Application Security',
  APPSEC_CONTAINER_SCAN: 'Containers',
  APPSEC_DASHBOARD: 'Dashboard',
  APPSEC_DAST: 'DAST',
  APPSEC_SAST: 'SAST',
  APPSEC_SBOM: 'SBOM',
  APPSEC_SCA: 'SCA',
  APPSEC_SECRETS: 'Secrets',
  APPROVED_SOFTWARE: 'Approved Software',
  CHAT_LOGS: 'Conversation Logs',
  CHAT_ASSISTANT: 'Qalea',
  CHAT_USER: 'You',
  CHAT_PLACEHOLDER: 'Type a message...',
  CHAT_LIMIT_REACHED: 'Your organization has reached the monthly chatbot usage limit. Please contact support.',
  ASSETS: 'Assets',
  ASSET_INVENTORY: 'Asset Inventory',
  GOVERNANCE: 'Governance',
  SECURITY: 'Security',
  OPERATIONS: 'Operations',
  DASHBOARD: 'Dashboard',
  WORKSPACE: 'Workspace',
  ASSET_MANAGEMENT: 'Asset Management',
  AUTOMATED_PENTESTING: 'Automated Pentesting',
  AWARENESS_TRAINING: 'Awareness Training',
  BACKOFFICE: 'Backoffice',
  BILLING: 'Billing',
  CLOUD_SECURITY: 'Cloud Security',
  CLOUD_SECURITY_DASHBOARD: 'Dashboard',
  CLOUD_MISCONFIGURANTIONS: 'Misconfigurations',
  CODE_SCANNER: 'Code Scanner',
  COMPLIANCE: 'Compliance',
  COMPLIANCE_DATA: 'Compliance Data',
  CONTROLS: 'Controls',
  CRISIS_MANAGER: 'Crisis Manager',
  CUSTOMER_SUCCESS: 'Customer Success',
  DOCUMENTS: 'Documents',
  TEXT_DOCUMENTS: 'Text Documents',
  EASM: 'External Surface',
  EASM_PUBLIC_DOMAINS: 'Public Domains',
  EASM_BREACHES: 'Known Breaches',
  EASM_CERTIFICATES: 'Certificates',
  EASM_DASHBOARD: 'Dashboard',
  EASM_VULNERABILITIES: 'External Vulnerabilities',
  EDR: 'EDR',
  EDR_SIEM: 'EDR & SIEM',
  EMPLOYEE_DASHBOARD: 'Dashboard',
  EMPLOYEES_TRAINING: 'Training and Awareness',
  EMPLOYEES_CENTER: 'Employee Center',
  ENDPOINTS_COMPLIANCE: 'Endpoints Compliance',
  ENDPOINT_PROTECTION: 'Endpoint Protection',
  ENDPOINT_MONITORING: 'Endpoint Monitoring',
  EVIDENCES: 'Evidences',
  SUPPLIER_QUESTIONNAIRES: 'Questionnaires',
  HOME: 'Home',
  INFRASTRUCTURE: 'Internal Vulnerabilities',
  VULNERABILITIES: 'Vulnerabilities',
  NON_CONFORMITIES: 'Non-Conformities Dashboard',
  PASSWORD_MANAGER: 'Password Management',
  PASSWORD_VAULT: 'Password Vault',
  PUBLIC_API: 'Public API',
  PEOPLE: 'Employees',
  PHISHING_EXERCISES: 'Phishing Campaigns',
  POLICIES: 'Policies',
  REPORTS: 'Reports',
  RISK_MANAGER: 'Risk Manager',
  ALERTS: 'Alerts',
  SERVERS_HARDENING: 'Servers Hardening',
  SERVERS: 'Servers',
  STANDARD_EDITOR: 'Standard Editor',
  SUPPLIERS: 'Suppliers',
  SUPPLIERS_DASHBOARD: 'Dashboard',
  TASKS: 'Task Manager',
  TRUST_CENTER: 'Trust Center',
  LAPTOPS: 'Laptops',
  CONNECTORS: 'Connectors',
  API: 'API',
  IDENTITIES: 'Identities',
  HOME_DASHBOARD: 'Home Dashboard',
  RISK_ASSESSMENT: 'Risk Assessment',
  MONITORING: 'Monitoring',
  OPERATIONAL_GOVERNANCE: 'Operational Governance',
  ORGANIZATION: 'Organization',
  ORGANIZATION_EMPLOYEE_DASHBOARD: 'Employee Dashboard',
  IT_INVENTORY: 'IT Inventory',
  ACCESS_REVIEW: 'Access Review',
  SAAS_MANAGEMENT: 'SaaS Management',
  AWARENESS: 'Awareness',
  PHISHING: 'Phishing',
  SCANS: 'Scans',
  MDM: 'MDM Pro',
  MDM_LITE: 'MDM Lite',
  MDM_HOSTS: 'Hosts',
  MDM_GROUPS: 'Groups',
  MDM_SOFTWARE: 'Software',
  MDM_DEVICE_POLICIES: 'Policies',
  MDM_SCRIPTS: 'Scripts',
  SIEM: 'SIEM',
}

export const COMMON = {
  UNAUTHORIZED_TITLE: 'Unauthorized',
  UNAUTHORIZED_DESCRIPTION:
    'You are not authorized to access this page, ' + 'please contact your administrator to request access.',
  DOWNLOAD: 'Download',
  SAVE: 'Save',
  SAVING: 'Saving...',
  STATUS: 'Status',
  VIEW: 'View',
  DELETE: 'Delete',
  CANCEL: 'Cancel',
  CONFIRM: 'Confirm',
  SHOW_LESS: 'Show less',
  SHOW_MORE: 'Show more',
  SELECT: 'Select',
  SEARCH: 'Search',
  NOT_FOUND: (label: string) => `No ${label} found.`,
  CLEAR: 'Clear',
  FILTER_BY: 'Filter by',
  OF: 'of',
  TOGGLE_SIDEBAR: 'Toggle Sidebar',
  ERROR_DIALOG_MESSAGE: 'Please check the information and try again.',
  CLOSE_BUTTON_TEXT: 'Close',
  COPIED_TO_CLIPBOARD: 'Copied to clipboard',
  ERROR_COPYING_TO_CLIPBOARD: 'Error copying to clipboard',
  COPY_CODE: 'Copy code',
  CREATING: 'Creating...',
  CREATE: 'Create',
  EDIT: 'Edit',
  OK: 'OK',
  LANGUAGES: {
    en: 'English',
    es: 'Spanish',
  },
}

export const PAYWALL = {
  NOT_AVAILABLE: {
    DESCRIPTION:
      'This feature is currently out of your capabilities scope, ' +
      'please send a request to expand or have a chat with Qalea team',
    TITLE: 'Extend your scope',
  },
  NOT_READY: {
    DESCRIPTION:
      "We're currently preparing this capability for you and it will be ready soon. " +
      "Once the setup is complete, you'll have full access to it. Thank you for your patience!",
    TITLE: 'Coming Soon',
  },
  UNDER_MAINTENANCE: {
    DESCRIPTION: 'This feature is currently under maintenance, please try again later.',
    TITLE: 'Under Maintenance',
  },
  REQUEST_EXTENSION: 'Request Extension',
  SCHEDULE_CALL: 'Schedule a Call',
}
